import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import LeadershipTable from './LeadershipTable';
const Leadership = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Leadership' parent='Leadership'  />
      <Container fluid={true}>
        <Row>
          <LeadershipTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Leadership;
